import { Inject, Injectable } from "@angular/core";
import { ConfirmOptionsModel } from "@nms-angular-toolkit/nms-table";
import { ANGULARJS_TRANSLATE } from "../upgraded-provider/upgraded-providers";
import { ConfirmModalOptions } from "./confirm-modal-options.model";

/**
 * Serviço responsável por tratar os dados para exibição de uma modal de confirmação.
 * Como este método está sendo sempre utilizado, criou-se um serviço para facilitar o tratamento.
 */
@Injectable({
    providedIn: "root"
})
export class ConfirmModalOptionsService {

    constructor(@Inject(ANGULARJS_TRANSLATE) private readonly translate: any){}

    getMessageForConfirmOptions(confirmModalOptions: ConfirmModalOptions): ConfirmOptionsModel {
        const { rowsSelectedLength: rowsSelected, singleSelectedRowKey, multipleSelectedRowsKey, title } = confirmModalOptions;
        const message = rowsSelected <= 1
                ? this.translate.instant(singleSelectedRowKey)
                : this.translate.instant(multipleSelectedRowsKey);

        return { title: this.translate.instant(title), description: message } as ConfirmOptionsModel;
    }
}
